<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong
                    >{{ partner.title }}: {{ discount_card.title }}</strong
                    >
                </CCardHeader>
                <CCardBody>
                    <!-- <PartnerDiscountCardTabLinks /> -->
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <div v-if="groups.length > 0 && !groupCreating" class="form-row">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"
                            >Группа</CCol
                            >
                            <CCol sm="9" class="col-form-label">
                                <CSelect
                                    inline
                                    :value.sync="discount_card.group_id"
                                    :options="groups"
                                    placeholder="Группа"
                                    @change="updateGroupId"
                                />
                                <CButton
                                    color="primary"
                                    class="mr-3"
                                    @click="groupCreating = true"
                                >Создать группу</CButton
                                >
                            </CCol>
                        </div>
                        <div v-if="groups.length === 0 || groupCreating" class="form-row">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"
                            >Группа</CCol
                            >
                            <CCol sm="9" class="col-form-label">
                                <CInput
                                    v-model="discount_card.group_title"
                                    placeholder="Введите название группы"
                                />
                                <CButton
                                    v-if="groups.length > 0"
                                    color="primary"
                                    class="mr-3"
                                    @click="groupCreating = false"
                                >Назад</CButton
                                >
                            </CCol>
                        </div>
                        <CInput
                            v-model="discount_card.priority"
                            label="Приоритет"
                            horizontal
                            placeholder="Введите приоритет скидочной карты в рамках выбранной группы"
                        />

                        <CInput
                            v-model="discount_card.title"
                            label="Название"
                            horizontal
                            placeholder="Введите название скидочной карты"
                        />
                        <CRow v-if="discount_card.picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="pictureUrl(discount_card.picture)"
                                class="m2"
                                width="300"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение"
                            horizontal
                            @change="selectPicture"
                        />
                        <CRow v-if="discount_card.picture_bg">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="pictureUrl(discount_card.picture_bg)"
                                class="m2"
                                width="300"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="picture_bg"
                            label="Фон карточки (picture_bg)"
                            horizontal
                            @change="selectPictureBg"
                        />
                        <CRow v-if="discount_card.logo">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="pictureUrl(discount_card.logo)"
                                class="m2"
                                width="100"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="logo"
                            label="Логотип"
                            horizontal
                            @change="selectLogo"
                        />
                        <CInput
                            v-model="discount_card.app_title"
                            label="Заголовок в приложении"
                            horizontal
                            placeholder="Введите заголовок для приложения"
                        />
                        <CTextarea
                            v-model="discount_card.app_description"
                            label="Описание в приложении"
                            horizontal
                            placeholder="Введите описание для приложения"
                            rows="4"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                С анимацией
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="discount_card.animated"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="discount_card.animated && discount_card.animation">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="pictureUrl(discount_card.animation)"
                                class="m2"
                                width="100"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="animation"
                            v-show="discount_card.animated"
                            label="Анимация"
                            horizontal
                            @change="selectAnimation"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показать на карте текущее время
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="discount_card.timed"
                                />
                            </CCol>
                        </CRow>
                        <CInput
                            v-model="discount_card.link"
                            label="Ссылка на карточку партнера"
                            horizontal
                            placeholder="Введите ссылку на карточку партнера"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="discount_card.enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать неавторизованным
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="discount_card.show_for_not_auth"
                                />
                            </CCol>
                        </CRow>

                        <hr class="my-4" />
                        <h5 class="mb-3">Google Wallet</h5>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Разрешить добавление в Google Wallet
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="discount_card.google_wallet_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CInput
                            v-model="discount_card.google_wallet_bg_color"
                            label="Цвет фона"
                            horizontal
                            placeholder="#1F3A60"
                        />
                        <CRow>
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label text-muted small">
                                HEX-цвет фона карты, например #1F3A60. Если не задан — используется #1F3A60.
                            </CCol>
                        </CRow>
                        <CRow v-if="discount_card.google_wallet_logo">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="pictureUrl(discount_card.google_wallet_logo)"
                                    class="m2"
                                    width="100"
                                />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="google_wallet_logo"
                            label="Логотип карты"
                            horizontal
                            @change="selectGoogleWalletLogo"
                        />
                        <CRow>
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label text-muted small">
                                Рекомендуемый формат: PNG. Минимальный размер логотипа: 660×660 px (квадрат 1:1).
                                Логотип отображается в круглой маске — оставьте ~15% отступа от краёв, не обрезайте заранее.
                            </CCol>
                        </CRow>
                        <CRow v-if="discount_card.google_wallet_image">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="pictureUrl(discount_card.google_wallet_image)"
                                    class="m2"
                                    width="300"
                                />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="google_wallet_image"
                            label="Картинка под картой"
                            horizontal
                            @change="selectGoogleWalletImage"
                        />
                        <CRow>
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label text-muted small">
                                Рекомендуемый формат: PNG. Рекомендуемый размер hero-изображения: 1032×812 px (соотношение ~5:4).
                                Если не задано — картинка в Google Wallet не передаётся.
                            </CCol>
                        </CRow>

                        <hr class="my-4" />
                        <h5 class="mb-3">Apple Wallet</h5>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Разрешить добавление в Apple Wallet
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="discount_card.apple_wallet_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CInput
                            v-model="discount_card.apple_wallet_bg_color"
                            label="Цвет фона"
                            horizontal
                            placeholder="#1F3A60"
                        />
                        <CRow>
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label text-muted small">
                                HEX-цвет фона карты, например #1F3A60. Если не задан — используется #1F3A60.
                            </CCol>
                        </CRow>
                        <CRow v-if="discount_card.apple_wallet_logo">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="pictureUrl(discount_card.apple_wallet_logo)"
                                    class="m2"
                                    width="160"
                                />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="apple_wallet_logo"
                            label="Логотип карты"
                            horizontal
                            @change="selectAppleWalletLogo"
                        />
                        <CRow>
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label text-muted small">
                                Рекомендуемый формат: PNG. Размер логотипа: до 160×50 pt
                                (320×100 px @2x, 480×150 px @3x). Обычно лучше делать уже максимальной ширины.
                            </CCol>
                        </CRow>
                        <CRow v-if="discount_card.apple_wallet_image">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="pictureUrl(discount_card.apple_wallet_image)"
                                    class="m2"
                                    width="300"
                                />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="apple_wallet_image"
                            label="Картинка под картой"
                            horizontal
                            @change="selectAppleWalletImage"
                        />
                        <CRow>
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label text-muted small">
                                Рекомендуемый формат: PNG. Размер strip-изображения для store card: 375×123 pt
                                (750×246 px @2x, 1125×369 px @3x). Если не задано — картинка в Apple Wallet не передаётся.
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true"
                    >Удалить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить акцию? Это действие
                        нельзя будет отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteDiscountCard"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnerDiscountCardTabLinks from '@/components/partner/PartnerDiscountCardTabLinks';

    export default {
        name: 'DiscountCardEdit',

        components: {
            PartnerDiscountCardTabLinks,
        },

        data() {
            return {
                partner: {},
                discount_card: {},
                groups: [],
                deleteModal: false,
                groupCreating: false,
                selectedPicture: null,
                selectedPictureBg: null,
                selectedAnimation: null,
                selectedLogo: null,
                selectedGoogleWalletLogo: null,
                selectedGoogleWalletImage: null,
                selectedAppleWalletLogo: null,
                selectedAppleWalletImage: null,
            };
        },

        mounted() {
            const id = parseInt(this.$route.params.id);
            const discount_card_id = parseInt(this.$route.params.discount_card_id);
            Vue.axios
                .get('/partners/' + id)
                .then(resp => {
                    this.partner = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get('/discount-cards/' + id + '/groups')
                .then(resp => {
                    this.groups = resp.data.map(el => {
                        return {
                            label: el.title,
                            value: el.id
                        }
                    });
                    if(this.groups.length === 0) {
                        this.groupCreating = true;
                    }
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get('/discount-cards/' + discount_card_id)
                .then(resp => {
                    delete resp.data.clients;
                    this.discount_card = {
                        ...resp.data,
                        google_wallet_enabled: resp.data.google_wallet_enabled !== false,
                        apple_wallet_enabled: resp.data.apple_wallet_enabled !== false,
                        google_wallet_bg_color: resp.data.google_wallet_bg_color || '',
                        apple_wallet_bg_color: resp.data.apple_wallet_bg_color || '',
                    };
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            pictureUrl(picture) {
                return picture ? (process.env.VUE_APP_STATIC_BASE_URL + '/' + picture) : '';
            },

            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
            selectPictureBg(FileList) {
                this.selectedPictureBg = FileList[0];
            },
            selectAnimation(FileList) {
                this.selectedAnimation = FileList[0];
            },
            selectLogo(FileList) {
                this.selectedLogo = FileList[0];
            },
            selectGoogleWalletLogo(FileList) {
                this.selectedGoogleWalletLogo = FileList[0];
            },
            selectGoogleWalletImage(FileList) {
                this.selectedGoogleWalletImage = FileList[0];
            },
            selectAppleWalletLogo(FileList) {
                this.selectedAppleWalletLogo = FileList[0];
            },
            selectAppleWalletImage(FileList) {
                this.selectedAppleWalletImage = FileList[0];
            },
        
            updateRouteName(e) {
                this.discount_card.group_id = e.target.value;
            },

            async save() {
                if (!this.groupCreating && !this.discount_card.group_id) {
                    this.$root.$emit('showError', 'Укажите группу скидочной карты.');
                    return;
                }
                if (this.groupCreating && !this.discount_card.group_title) {
                    this.$root.$emit('showError', 'Укажите название группы скидочной карты.');
                    return;
                }
                if (!this.discount_card.title) {
                    this.$root.$emit('showError', 'Укажите название скидочной карты.');
                    return;
                }
                this.discount_card.partner_id = this.partner.id;
                this.discount_card.enabled = this.discount_card.enabled ? true : false;
                this.discount_card.animated = this.discount_card.animated ? true : false;
                this.discount_card.timed = this.discount_card.timed ? true : false;
                this.discount_card.show_for_not_auth = this.discount_card.show_for_not_auth ? true : false;
                this.discount_card.google_wallet_enabled = this.discount_card.google_wallet_enabled ? true : false;
                this.discount_card.apple_wallet_enabled = this.discount_card.apple_wallet_enabled ? true : false;
                this.discount_card.google_wallet_bg_color = this.discount_card.google_wallet_bg_color || null;
                this.discount_card.apple_wallet_bg_color = this.discount_card.apple_wallet_bg_color || null;
                this.discount_card.priority = +this.discount_card.priority;
            
                if(this.groupCreating) {
                    this.discount_card.group_id = null;
                }


                // Загружаем картинку
                if(this.selectedPicture) {
                    this.discount_card.picture = await this.uploadPicture(this.selectedPicture);
                }
                if(this.selectedPictureBg) {
                    this.discount_card.picture_bg = await this.uploadPicture(this.selectedPictureBg);
                }
                if(this.selectedAnimation) {
                    this.discount_card.animation = await this.uploadPicture(this.selectedAnimation);
                }
                if(this.selectedLogo) {
                    this.discount_card.logo = await this.uploadPicture(this.selectedLogo);
                }
                if(this.selectedGoogleWalletLogo) {
                    this.discount_card.google_wallet_logo = await this.uploadPicture(this.selectedGoogleWalletLogo);
                }
                if(this.selectedGoogleWalletImage) {
                    this.discount_card.google_wallet_image = await this.uploadPicture(this.selectedGoogleWalletImage);
                }
                if(this.selectedAppleWalletLogo) {
                    this.discount_card.apple_wallet_logo = await this.uploadPicture(this.selectedAppleWalletLogo);
                }
                if(this.selectedAppleWalletImage) {
                    this.discount_card.apple_wallet_image = await this.uploadPicture(this.selectedAppleWalletImage);
                }

                await this.axios.put(`/discount-cards/${this.discount_card.id}`, this.discount_card);
                this.goBack();
            },

            async uploadPicture(picture) {
                if(picture) {
                    const formData = new FormData();
                    formData.append('file', picture);
                    const resp = await this.axios.post('/files/upload', formData);
                    console.log(resp);
                    return resp.data.filename;
                }
            },

            deleteDiscountCard() {
                Vue.axios
                    .delete('/discount-cards/' + this.discount_card.id)
                    .then(resp => {
                        this.$router.push({
                            path:
                                '/partners/' +
                                this.partner.id +
                                '/discount-cards',
                        });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            goBack() {
                this.$router.push({
                    path: `/partners/${this.partner.id}/discount-cards/${this.discount_card.id}`
                });
            },
        },
    };
</script>
